import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";

export default function ChatInput({
  isShowInitialChat = true,
  textareaRef,
  inputMessage,
  setInputMessage,
  handleKeyPress,
  isTyping,
  isStreaming,
  onSend,
  onFilesSelected, // optional: callback lên cha
  inputPlaceholder,
  showUploadButton = true,
  resetFilesKey = 0,
}) {
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);

  // Clear internal files when parent toggles resetFilesKey
  useEffect(() => {
    if (files.length > 0) {
      setFiles([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      onFilesSelected?.([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFilesKey]);

  const handleAttachButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const picked = Array.from(e.target.files || []);
    setFiles((prev) => {
      const existing = new Set(
        prev.map((f) => `${f.name}-${f.size}-${f.lastModified}`)
      );
      const merged = [...prev];
      picked.forEach((f) => {
        const key = `${f.name}-${f.size}-${f.lastModified}`;
        if (!existing.has(key)) merged.push(f);
      });
      onFilesSelected?.(merged); // Send all files including new ones
      return merged;
    });
    // reset value để có thể chọn lại cùng 1 file
    e.target.value = "";
  };

  const removeFileAt = (idx) => {
    setFiles((prev) => {
      const newFiles = prev.filter((_, i) => i !== idx);
      onFilesSelected?.(newFiles); // Send all remaining files
      return newFiles;
    });
  };

  return (
    <div
      className={`${
        isShowInitialChat ? "initial-input-area" : "chat-input-area"
      }`}
    >
      <div className="input-top-section">
        <InputTextarea
          ref={textareaRef}
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={inputPlaceholder}
          className="message-input"
          rows={1}
          autoResize
          name="message-input"
        />
      </div>

      <div className="input-bottom-section">
        {files.length > 0 && (
          <div className="file-chips">
            <div className="file-chip-wrap">
              {files.map((f, idx) => (
                <div className="file-chip" key={`${f.name}-${idx}`}>
                  <i className="pi pi-file file-icon" />
                  <span className="file-name" title={f.name}>
                    {f.name}
                  </span>
                  <button
                    type="button"
                    className="chip-remove"
                    onClick={() => removeFileAt(idx)}
                    aria-label={`Remove ${f.name}`}
                  >
                    <i className="pi pi-times" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="input-actions-container">
          <div className="input-actions-left">
            {showUploadButton && (
              <>
                <input
                  type="file"
                  ref={fileInputRef}
                  multiple
                  accept=".txt,.md,.json,.csv,text/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <Button
                  onClick={handleAttachButtonClick}
                  className="p-button-text p-button-rounded attach-btn"
                  icon="pi pi-paperclip text-lg"
                  title="Attach file"
                />
              </>
            )}
          </div>
          <div className="input-actions-right">
            <Button
              onClick={onSend}
              disabled={
                (!inputMessage.trim() && files.length === 0) ||
                isTyping ||
                isStreaming
              }
              className="send-button p-button-rounded"
              icon="pi pi-send text-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
